import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import "../../ClosedLoop/Dashboard.less"
import { withRouter } from "../../../lib/withRouter"
import { formatDate, getViewPatientData, postResource } from "../../../lib"
import moment from "moment"
import RangePicker from "../../ClaimReview/RangePicker"
import { ArrowDownUp } from "lucide-react"

export class MirthEMPI extends React.Component {
    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        selectedLog: PropTypes.object,
        onClose: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            empiData: null,
            loading: false,
            error: null,
        };
    }

    componentDidMount() {
        console.log("Selected Referral for Detail View", this.props.selectedLog);
        this.fetchEMPIData();
    }

    fetchEMPIData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const baseUrl = this.props.settings.server.baseUrl;

            const empiApi = `${baseUrl}/mirth/empi/latest?mrn=${this.props.selectedLog?.mrn}`;

            const [empiRes] = await Promise.all([
                getViewPatientData({
                    url: empiApi,
                    server: this.props.settings.server
                })
            ]);

            console.log("EMPI Data:", empiRes);

            this.setState({
                empiData: empiRes || null,
                loading: false
            });

        } catch (error) {
            console.error("Dashboard fetch failed:", error);
            this.setState({ loading: false, error: error.message });
        }
    };

    parseJSON = (val) => {
        if (!val) return null;
        try {
            return typeof val === "string" ? JSON.parse(val) : val;
        } catch {
            return val;
        }
    };

    render() {
        const { selectedLog, onClose } = this.props;
        return (
            <>
                <div className="patient-sidebar-overlay" onClick={onClose}>
                    <div className="patient-sidebar clr-sidebar" onClick={e => e.stopPropagation()}>

                        {/* Header */}
                        <div className="sidebar-header">
                            <div style={{ display: "flex", alignItems: "center", columnGap: "3rem" }}>
                                <span style={{ display: "flex", alignItems: "center", columnGap: "0.5rem" }}>
                                    Patient Name: <h4>{this.state.loading ? <i className="fa fa-spinner fa-spin" /> : this.state.empiData?.patient_name || "-"}</h4>
                                </span>
                                <span style={{ display: "flex", alignItems: "center", columnGap: "0.5rem" }}>
                                    MRN: <h4>{this.state.loading ? <i className="fa fa-spinner fa-spin" /> : this.state.empiData?.mrn || "-"}</h4>
                                </span>
                                <span style={{ display: "flex", alignItems: "center", columnGap: "0.5rem" }}>
                                    EMPI Number: <h4>{this.state.loading ? <i className="fa fa-spinner fa-spin" /> : this.state.empiData?.empi || "-"}</h4>
                                </span>
                            </div>
                            <button className="close-btn" onClick={onClose}>
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div style={{ padding: "15px" }}>
                            {selectedLog.error_message && (
                                <div className="panel panel-primary" style={{ marginBottom: '10px' }}>
                                    <div className="panel-heading" style={{ padding: '8px 15px' }}>
                                        <h5 className="panel-title" style={{ margin: 0, fontSize: '14px' }}>
                                            <i className="fa fa-info-circle"></i> Error Message
                                        </h5>
                                    </div>
                                    <div className="panel-body" style={{ padding: '10px 15px' }}>
                                        {selectedLog.error_message}
                                    </div>
                                </div>
                            )}

                            {this.state.loading && (
                                <div style={{ textAlign: "center", padding: "20px" }}>
                                    <i className="fa fa-spinner fa-spin fa-2x" />
                                </div>
                            )}

                            {!this.state.loading && this.state.empiData && (
                                <div style={{ display: "flex", gap: "15px" }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <h5>Request</h5>
                                        <pre style={{
                                            maxHeight: "70vh",
                                            overflow: "auto",
                                            background: "#1e1e1e",
                                            color: "#d4d4d4",
                                            padding: "15px",
                                            borderRadius: "6px",
                                            fontSize: "12px"
                                        }}>
                                            {JSON.stringify(this.parseJSON(this.state.empiData.request), null, 2)}
                                        </pre>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <h5>Response</h5>
                                        <pre style={{
                                            maxHeight: "70vh",
                                            overflow: "auto",
                                            background: "#1e1e1e",
                                            color: "#d4d4d4",
                                            padding: "15px",
                                            borderRadius: "6px",
                                            fontSize: "12px"
                                        }}>
                                            {JSON.stringify(this.parseJSON(this.state.empiData.response), null, 2)}
                                        </pre>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div >
            </>
        );
    }
}

export default connect(state => state)(withRouter(MirthEMPI));